import React from "react";
import "./Content.scss";
import EngagedSection from "./EngagedSection";
import ParallaxPhoto from "./ParallaxPhoto";
import Schedule from "./Schedule";
import Transport from "./Transport";
import Counter from "./Counter";
import ConfirmationContainer from "./ConfirmationContainer";
import Godparents from "./Godparents";

function Content({ t }) {
  return (
    <div className="relative">
      <EngagedSection t={t} />
      <ParallaxPhoto photoClass="parallax-engaged">
        <h1 id="schedule" className="text-white text-center">
          {t.program}
        </h1>
      </ParallaxPhoto>
      <Schedule t={t} />
      <Transport t={t} />
      <Godparents t={t} />
      <Counter t={t} />
      {/* <ParallaxPhoto photoClass="parallax-our-story">
        <br />
        <h1 id="history" className="text-white text-center">
          И КОЙ КАЗА?
        </h1>
        <br />
      </ParallaxPhoto> */}
      <ConfirmationContainer t={t} />

      <div className="p-top-12 p-top-4-xs bg-base p-bottom-6 text-center text-primary">
        <h5 className="text-primary">{t.withLove}</h5>
        <h3 className="text-primary">Katerina & Ilian</h3>
        <div className="heart m-auto"></div>
        <div className="container m-auto flex p-top-12 p-top-8-xs">
          <hr className="flex flex-justify-center col-12-xs col-12-sm col-8 hr-style m-top-2 m-bottom-2 m-left-auto m-right-auto text-primary" />
        </div>
        <div className="text-primary">{t.copyright}</div>
        <div>
          {t.author}
          <i className="m-left-1 fa-solid fa-hand-holding-heart"></i>
        </div>
      </div>
    </div>
  );
}

export default Content;
